import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { LogController } from '../log/LogController';
import { SecurityController } from './security.controller';
import { AlertService } from '../../services/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { HString } from '@shared/src/public-api';

/***
 * Es el filtre de la seguretat. Assegura al cridar-se cada opció, si està protegida per aquest que es pot accedir-hi
 */
@Injectable()
export class AuthGuard implements CanActivate {


  constructor(@Inject('SecurityController') protected securityController: SecurityController, 
  private logController: LogController, 
  @Inject('AlertService') protected alertService: AlertService,
  protected translateService: TranslateService,
  protected router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.securityController.isSecurityLoaded()) {
      return this.calculateSecurity(route, state).then(value => {
        if (typeof value === 'boolean') {
          this.logController.navigate(route.routeConfig.path, value);
        }
        return value;
      });
    }

    return new Promise(resolve => {
      const sub: Subscription = this.securityController.securityLoaded$.subscribe(value => {
        sub.unsubscribe();
        this.calculateSecurity(route, state).then(value => {
          if (typeof value === 'boolean') {
            this.logController.navigate(route.routeConfig.path, value);
          }
          resolve(value);
        });
      });
    });
  }

  private calculateSecurity(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise(resolve => {
      this.securityController.isLogged().subscribe(value => {
        if (value) {
          let pathreal = state.url;
          let pathvirtual = route.routeConfig.path;
          try {
            return this.securityController.canAccess(pathreal, pathvirtual).subscribe(canaccess => {
              if(!canaccess){
                this.translateService.get("AUTHCUARD.CANNOTACCESSPATH", { value: pathreal }).subscribe((text: string) => {
                  console.log(text);
                  this.alertService.error(text, false);
                })
              }
              resolve(canaccess);
            });
          }
          catch {
            resolve(false);
          }
        } else {
          resolve(this.router.createUrlTree(['/login']));
        }
      });
    });
  }
} 
